import React from "react";

export const ProductAdded = () => (
<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14.0869 2.3877C14.2043 2.27027 14.3943 2.27031 14.5117 2.3877C14.6292 2.50514 14.6292 2.69506 14.5117 2.8125L7.91113 9.41211C7.85253 9.47066 7.77627 9.5 7.69922 9.5C7.62217 9.49996 7.54588 9.47068 7.4873 9.41211L5.08691 7.0127C4.9695 6.89528 4.96957 6.70534 5.08691 6.58789C5.20436 6.47045 5.39428 6.47045 5.51172 6.58789L7.4873 8.56348L7.69922 8.77637L7.91113 8.56348L14.0869 2.3877Z"
    fill="#703EFF"
    stroke="#9897A9"
    strokeWidth="0.6"
  />
  <path
    d="M7.69961 14.6004C4.06061 14.6004 1.09961 11.6394 1.09961 8.00039C1.09961 4.36139 4.06061 1.40039 7.69961 1.40039C8.70881 1.40039 9.67781 1.62239 10.5796 2.06039C10.8778 2.20499 11.002 2.56379 10.8574 2.86199C10.7128 3.16019 10.354 3.28439 10.0558 3.13919C9.31841 2.78099 8.52581 2.59979 7.69961 2.59979C4.72181 2.60039 2.29961 5.02319 2.29961 8.00039C2.29961 10.9776 4.72181 13.4004 7.69961 13.4004C10.6774 13.4004 13.0996 10.9776 13.0996 8.00039C13.0996 7.72199 13.0786 7.44239 13.0366 7.16939C12.9862 6.84179 13.2106 6.53519 13.5382 6.48479C13.8658 6.43559 14.1724 6.65879 14.2228 6.98639C14.2744 7.31939 14.3002 7.66079 14.3002 7.99979C14.3002 11.6388 11.3392 14.5998 7.70021 14.5998L7.69961 14.6004Z"
    fill="#9897A9"
  />
</svg>

);

